const EmployeeDialogs = {
  EDIT_ENROLLMENT: 'EDIT_ENROLLMENT',
  EDIT_EMPLOYEE: 'EDIT_EMPLOYEE',
  QUALIFYING_EVENT: 'QUALIFYING_EVENT',
  CANCEL_BENEFIT: 'CANCEL_BENEFIT',
  ELECT_COBRA: 'ELECT_COBRA',
  CANCEL_COBRA: 'CANCEL_COBRA',
  SEARCH_FAMILY: 'SEARCH_FAMILY',
  ADD_NEW_FAMILY: 'ADD_NEW_FAMILY',
  MEMBER_EXISTS: 'MEMBER_EXISTS',
};

export default EmployeeDialogs;
